module.exports = __webpack_public_path__ + "static/media/LCD-prosessi-vaaka-en.5102e152.svg";